import {Component, Input} from '@angular/core';
import {StoryCard} from "../story-card";
import {AnimationItem} from "lottie-web";
import {AccessibilityService} from "../../../services/accessibility.service";
import {take} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-cover-card',
  templateUrl: './cover-card.component.html',
  styleUrls: ['./cover-card.component.scss']
})
export class CoverCardComponent {

  animation!: AnimationItem;
  imageLoaded = false;
  @Input('card-data') set setCardData(val: StoryCard) {
    this.cardData = val;
  };
  @Input('isPreview') isPreview = false; // using as preview in story-preview component or in story overlay as first card (animation behaviour)
  @Input('label') label = "";

  cardData!: StoryCard;

  animationsAllowed = true;

  constructor(private accessibilityService: AccessibilityService) {
    this.accessibilityService.getStopMovingContent().pipe(untilDestroyed(this)).subscribe((val) => {
      this.animationsAllowed = !val;
    })
  }

  onBackgroundImageLoaded() {
    this.imageLoaded = true;
  }

  onAnimationCreated($event: AnimationItem) {
    this.animation = $event;

    if(!this.isPreview) {
      this.animation.loop = true;
      this.animation.play();
    }
  }

  onMouseEnter($event: MouseEvent) {
    if(!this.animationsAllowed || !this.isPreview || !this.animation) return;
      this.animation.loop = true;
      this.animation.goToAndPlay(0);
  }

  onMouseLeave() {
    if(this.isPreview) {
      if(this.animation) {
        this.animation.loop = false;
      }
    }
  }
}
